import { render } from "./typeIdReplace2.vue?vue&type=template&id=13cc29ee&scoped=true"
import script from "./typeIdReplace2.vue?vue&type=script&lang=js"
export * from "./typeIdReplace2.vue?vue&type=script&lang=js"

import "./typeIdReplace2.vue?vue&type=style&index=0&id=13cc29ee&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cc29ee"]])

export default __exports__